import React, { Component } from 'react';
import { toast } from 'react-toastify';

import Spinner from 'components/Spinner';
import BaseModal from '../BaseModal';
import { getCustomerUrl } from 'helpers/url';
import { getCarrier } from 'helpers/getCarrier';
import { getSubStatus } from 'helpers/subs';

import styles from './styles.module.scss';

class SetPlanModal extends Component {
  constructor(props) {
    super(props);
    this.checkboxRef = React.createRef();
    this.state = {
      checked: false,
      submitted: false,
      loading: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { planName, planCarrier, changeField } = this.props;
    if (prevProps.planName && prevProps.planName !== planName) {
      changeField('plan', 'plan_price', '');
    }

    if (prevProps.planCarrier && prevProps.planCarrier !== planCarrier) {
      changeField('plan', 'plan_name', '');
    }

    if (!prevProps.isOpen && this.props.isOpen) {
      this.fetchPlans();
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  fetchPlans() {
    const { fetchAllPlans, subId, isOpen } = this.props;
    if (isOpen) {
      const params = { subscription_id: subId };

      this.setState({ loading: true });
      fetchAllPlans(params)
        .catch((e) => toast.error('Failed to load subscription plans'))
        .finally(() => this.setState({ loading: false }));
    }
  }

  handleChangePlan = async (values) => {
    const { subId, sub, updatePlan, lockPlan, isQuick, isAtt } = this.props;

    if (isAtt || isQuick) {
      if (sub.plan && sub.plan.id === values.plan_id) {
        return lockPlan(subId, values.plan_lock);
      } else {
        const { plan_lock, ...planValues } = values;
        if (plan_lock) {
          return updatePlan(subId, planValues).then(() =>
            lockPlan(subId, plan_lock),
          );
        } else {
          return updatePlan(subId, planValues);
        }
      }
    }

    return updatePlan(subId, values);
  };

  resetAttFormValues = () => {
    const { changeField } = this.props;

    changeField('plan', 'plan_carrier', '');
    changeField('plan', 'plan_name', '');
    changeField('plan', 'plan_price', '');
  };

  renderRenewalMarkup = () => (
    <React.Fragment>
      <h1>{this.props.heading}</h1>
      <div className="mar-t">
        Today is the renewal day. You are not supposed to update plan
      </div>
    </React.Fragment>
  );

  render() {
    const {
      subId,
      sub,
      user,
      heading,
      updatePlan,
      updatePurchaseId,
      preactivation,
      plans,
      isReseller,
      isAdmin,
      PlanForm,
      showLockCheckbox,
      showSplittedForm,
      isOpen,
      closeModal,
      ...props
    } = this.props;
    const { submitted, loading } = this.state;

    const { plan, plan_locked } = sub;
    const carrier = getCarrier(sub);
    const subStatus = getSubStatus(sub);
    const isAtt = carrier === 'att';
    const isQuick = carrier === 'quick';
    let initialValues =
      (isAtt || isQuick) && showSplittedForm
        ? {
            plan_name: plan && plan.name,
            plan_price: plan && plan.price,
            plan_carrier: (sub && sub.plan && sub.plan.plan_carrier) || '',
            plan_lock: plan_locked,
          }
        : { plan_id: plan && plan.id, plan_lock: plan_locked };

    if (plan && !plans.find((p) => plan.id === p.id)) {
      initialValues = {};
    }

    let requestedPlan;
    if (preactivation && preactivation.plan) {
      requestedPlan = preactivation.plan;
    }

    // inject custom plan price and remove regular plans for business users
    let injectedPlans = [].concat(plans);
    const customerUrl = getCustomerUrl();
    let url = `${customerUrl}purchase/${updatePurchaseId}`;
    let adminPurchaseUrl = '';

    const showCarrierDropdown = isAtt && subStatus !== 'active';
    const showForce =
      carrier === 'att' &&
      isAdmin &&
      sub &&
      sub.synced_with_att &&
      sub.att_status === 'active';

    if (!PlanForm) {
      return false;
    }

    return (
      <BaseModal
        isOpen={isOpen}
        title={heading}
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <PlanForm
          {...props}
          sub={sub}
          requestedPlan={requestedPlan}
          initialValues={initialValues}
          onSubmit={this.handleChangePlan}
          {...{ subId }}
          plans={injectedPlans}
          refs={this.checkboxRef}
          showLockCheckbox={showLockCheckbox}
          showCarrierDropdown={showCarrierDropdown}
          resetAttFormValues={this.resetAttFormValues}
          showForce={showForce}
          isQuick
          isModal
        />
        {updatePurchaseId && submitted && (
          <div className="mar-t">
            <a href={url}>View Purchase on customer site</a> <br />
            <a href={adminPurchaseUrl}>View Purchase on admin site</a>
          </div>
        )}
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default SetPlanModal;
